import React, { useState } from 'react';
import { MenuItems } from './menuItems';
import './dropdown.css';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

function Dropdown() {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const { t } = useTranslation();

  return (
    <>
      <ul
        onClick={handleClick}
        className={click ? 'dropdown-menu clicked' : 'dropdown-menu'}
      >
        {MenuItems.map((item, index) => {
          return (
            <li key={index}>
              <Link
                className={item.cName}
                to={item.path}
                onClick={() => setClick(false)}
              >
                {t(item.title)}
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default Dropdown;
